export const findInstallationPointsByAssetCodes = (data: any[]): Map<string, any> => {
  const result = new Map<string, any>();

  for (const facility of data) {
    const relevantEquipments = (facility.locations ?? []).flatMap(
      (location: any) => location.equipments ?? [],
    );

    for (const equipment of relevantEquipments) {
      for (const installationPoint of equipment.installationPoints) {
        result.set(installationPoint.originName, {
          ...installationPoint,
          equipmentId: equipment.id,
        });
      }
    }
  }
  return result;
};
